module.exports = __webpack_public_path__ + "static/karl-4eb96738daded131f98373cb3750edcd.jpg";